import type React from "react";

type Props = {
  idx: string;
  titlesx: string;
  children: React.ReactNode;
};

export const InputsForm = ({ idx, titlesx, children }: Props): JSX.Element => {
  return (
    <div className="form-group">
      <label className="develop___text develop___font_text" htmlFor={idx}>
        {titlesx}
      </label>
      {children}
    </div>
  );
};
